export const STATUS_CLS = {
  Available: "bg-emerald-500 text-white",
  "Partially Available": "bg-amber-400 text-navy",
  "Fully Booked": "bg-magenta text-white",
  Unavailable: "bg-slate-300 text-slate-700",
  "Schedule Not Submitted": "bg-white text-dark-text/40 border border-dashed border-navy/20",
};

export const Legend = () => (
  <div className="flex flex-wrap gap-3 text-xs" data-testid="availability-legend">
    {Object.entries(STATUS_CLS).map(([k, c]) => <span key={k} className="inline-flex items-center gap-1.5"><span className={`w-3 h-3 rounded-sm ${c}`} />{k}</span>)}
  </div>
);

const slotText = (s) => (s.full_day ? "All day" : `${s.start || "?"}–${s.end || "?"}`) + ` ${s.format === "In person" ? "IP" : s.format === "Both" ? "V/IP" : "V"}`;

export const MonthGrid = ({ month, days, compact = false }) => {
  const first = new Date(`${month}-01T12:00:00`).getDay();
  const pad = (first + 6) % 7;
  return (
    <div>
      <div className="grid grid-cols-7 gap-1 text-[10px] font-bold text-dark-text/50 uppercase mb-1">{["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"].map((d) => <span key={d} className="text-center">{d}</span>)}</div>
      <div className="grid grid-cols-7 gap-1" data-testid="month-grid">
        {Array.from({ length: pad }).map((_, i) => <span key={`p${i}`} />)}
        {days.map((d) => (
          <div key={d.date} title={`${d.date}: ${d.status}`} className={`rounded-md p-1 ${compact ? "h-8" : "min-h-[64px]"} ${STATUS_CLS[d.status]}`} data-testid={`day-${d.date}`}>
            <p className="text-[11px] font-bold">{Number(d.date.slice(8))}</p>
            {!compact && d.slots.slice(0, 2).map((s, i) => <p key={i} className="text-[9px] leading-tight truncate">{slotText(s)}</p>)}
          </div>
        ))}
      </div>
      <div className="mt-3"><Legend /></div>
    </div>
  );
};

export { slotText };
